export enum EncryptionType {
  Encrypt = 'encrypt',
  Decrypt = 'decrypt',
}
